import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'app/shared/components/button/button.module';
import { InputBoxModule } from 'app/shared/components/input-box/input-box.module';
import { ModalModule } from 'app/shared/components/modal/modal.module';
import { TextAreaModule } from 'app/shared/components/text-area/text-area.module';
import { MapRegisterComponent } from './map-register.component';

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ModalModule,
    InputBoxModule,
    TextAreaModule,
    ButtonModule,
  ],
  declarations: [MapRegisterComponent],
  exports: [MapRegisterComponent],
})
export class MapRegisterModule {}
